
import { removeAllSpace } from '@/mixins/shared';
import { ApiService, BarrelDocumentsOutput } from '@/services/ApiService';
import mixins from "vue-typed-mixins";
import { error } from '@/services/LoggerService';
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import StackingNotification from "@/components/StackingNotification.vue";
import StackingNotificationMixin from "@/mixins/StackingNotificationMixins";
export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin, StackingNotificationMixin).extend({
  name: "ViewDocuments",
  components: { SnackbarNotifier, ConfirmationModal, StackingNotification },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    search: '',
    headers: [
      {text: 'Re-upload', value: 'reUpload'},
      {text: 'Document Name', value: 'Name'},
      {text: 'Reupload Requested', value: 'ReuploadRequested'},
      {text: 'Collected', value: 'Collected'},
      {text: 'Open', value: 'open'},
    ],
    barrelActive: false,
    documents: [] as BarrelDocumentsOutput[],
    selectedDocumentName: '',
    loading: false,
  }),
  computed: {
    documentUploadLink() {
      return `${window.location.origin}/document/${this.id}`;
    }
  },
  methods: {
    copyDocumentUploadLink(){
      navigator.clipboard.writeText(this.documentUploadLink);
        this.addNotification({
          message: `The document upload link has been copied to the clipboard \n ${this.documentUploadLink}`
        });
    },
    async retrieveDocumentLink(documentName: string){
      try {
        const link = await ApiService.Instance.getDocumentDownloadLink({
          id: this.$props.id,
          documentName: removeAllSpace(documentName)
        })
        if(link) window.open(link, '_blank')?.focus();
      } catch (err) {
        this.showNotifier({
          message: 'Failed To Open Document',
          snackbarType: "error",
        });
        error(err);
        throw new Error('Error in retrieveDocumentLink()');
      }
    },
    confirmReuploadRequest(documentName: string){
      this.$data.selectedDocumentName = documentName;
      this.showConfirmationModal({
        title: 'Request Re-upload',
        message: `Are you sure you want to request a <strong>re-upload</strong> of <strong><em>${documentName}</em></strong>?`,
        confirmButtonTitle: 'Yes'
      });
    },
    async requestReupload(){
      try {
        this.startConfirmationLoading();
        const user = this.$store.getters.getUser.attributes.name;
        await ApiService.Instance.requestDocumentReupload({
          id: this.id,
          documentName: this.selectedDocumentName,
          user
        })
        this.addNotification({
          message: `Email has been sent requesting a re-upload for <strong><em>${this.selectedDocumentName}</em></strong>`
        });
        this.$nextTick(async() => {
          await this.getBarrelDocuments(this.id);
        });
        this.stopConfirmationLoading();
      } catch (err) {
        this.stopConfirmationLoading();
        this.errorOperation({
          notificationErrorMessage: 'Failed To Request Reupload Documents',
          thrownErrorMessage: 'Error in requestReupload()',
          err
        })
      }
    },
    async getBarrelDocuments(id: string){
      try {
        this.loading = true;
        const info = await ApiService.Instance.getBarrelDocuments(id);
        if(info){
          this.$data.documents = info.documents
          this.$data.barrelActive = info.barrelActive
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.errorOperation({
          notificationErrorMessage: 'Failed To Retrieve Documents',
          thrownErrorMessage: 'Error in getBarrelDocuments()',
          err
        })
      }
    },
    errorOperation(input:{notificationErrorMessage: string,thrownErrorMessage: string, err:unknown}){
      this.showNotifier({
          message: input.notificationErrorMessage,
          snackbarType: "error",
        });
        error(input.err);
        throw new Error(input.thrownErrorMessage);
    },
    chipColor(input: boolean){
      return input ? 'rgb(108, 255, 178)' : 'rgb(255, 191, 0)'
    },
    chipWord(input: boolean){
      return input ? 'Yes' : 'No'
    }
  },
  async mounted(){
    const id = this.$props.id;
    await this.getBarrelDocuments(id);
  }
})
